import React, {
    useEffect,
    useRef,
    useState,
} from "react";

import Prince from "../../Components/Prince";
import TopHeader from "../../Components/TopHeader";

import {
    useLocation,
    useNavigate,
    useParams,
} from "react-router-dom";

import B2BActivityLeadStageModal from "./b2bactivityleadStage";
import { B2BUpdateLead } from "./b2bUpdateLead";
import { B2BPlanQuations } from "./b2bplanQuations";
import B2BActivityLeadTypeModal from "./b2bactivityleadType";
import B2BActivityQuationsModal from "./b2bactivityLeadQuations";
import B2BActivityMettingUpdateModal from "./b2bactivityMettingUpdate";
import B2BActivityContactModal from "./b2bactivityContact";
import B2BActivityPostCommentModal from "./b2bpostComment";
import B2BWonLeadModal from "./b2bwonLead";
import B2BBulkLeadSoureModal from "./b2bbulkLeadSource";
import B2BLostLeadModal from "./b2blostLead";



// import * as b2cleadService from "../../Services/b2cleadService"

import * as b2bleadService from "../../Services/b2bleadService";

import { toast } from "react-toastify";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

export const B2BLeadActivity = () => {

    const navigate = useNavigate();

    const location = useLocation();
    const [leadDetails, setLeadDetails] = useState({});
    const { empid } = useParams();

    // =========================================
    // PREVIOUS LIST TAB
    // =========================================

    const previousTab =
        location?.state?.previousTab || "new";

    // =========================================
    // ACTIVITY PAGE TAB
    // =========================================

    const [activityTab, setActivityTab] =
        useState("followup");

    // =========================================
    // MODAL REFS
    // =========================================

    const b2cactivitystageleadRef = useRef(null);

    const b2cactivityleadtypeRef = useRef(null);

    const b2cactivityquationsRef = useRef(null);

    const b2cactivitymettingupdateRef = useRef(null);

    const b2cactivitycontactRef = useRef(null);

    const b2cactivitycommentpostRef = useRef(null);

    const b2cactivitywonleadRef = useRef(null);

    const b2cactivitylostleadRef = useRef(null);
    const [activityComments, setActivityComments] = useState([]);
    // const [activeAction, setActiveAction] = useState({});
    // const [doneComments, setDoneComments] = useState({});
    // const [cancelComments, setCancelComments] = useState({});

    const [selectedCommentId, setSelectedCommentId] = useState(null);
    const [actionType, setActionType] = useState("");
    const [actionComment, setActionComment] = useState("");

    const [callSelectedId, setCallSelectedId] = useState(null);
    const [callActionType, setCallActionType] = useState("");
    const [callActionComment, setCallActionComment] = useState("");

    const tabs = [
        {
            label: "FOLLOWUP",
            value: "followup",
        },

        {
            label: "UPDATE",
            value: "update",
        },

        // {
        //     label: "PLAN QUOTATION",
        //     value: "quotation",
        // },
    ];

    // =========================================
    // REMOVE MODAL BACKDROP ISSUE
    // =========================================

    useEffect(() => {

        document.body.classList.remove(
            "modal-open"
        );

        document.body.style.overflow = "";

        document.body.style.paddingRight = "";

        const backdrops =
            document.querySelectorAll(
                ".modal-backdrop"
            );

        backdrops.forEach((el) =>
            el.remove()
        );

    }, []);

    // =========================================
    // HANDLE BACK
    // =========================================

    const handleBack = () => {

        navigate("/b2b/lead", {
            state: {
                activeTab: previousTab,
                // filters: location?.state?.filters,
            },
        });

    };

    useEffect(() => {

        getData();
        getLeadFollowup();

    }, [empid]);

    const getData = () => {

        if (!empid) return;

        b2bleadService
            .getLeadById(empid)

            .then((res) => {

                if (
                    res?.data?.status ===
                    "success"
                ) {

                    setLeadDetails(
                        res?.data?.data || {}
                    );
                    //      setActivityComments(
                    //     res?.data?.data?.comments || []
                    // );

                }

            })

            .catch((error) => {

                console.log(
                    "Lead detail error",
                    error
                );

            });

    };

    const getLeadFollowup = () => {

        if (!empid) return;

        b2bleadService
            .getLeadFollowUP(empid)

            .then((res) => {

                if (
                    res?.data?.status === "success"
                ) {

                    setActivityComments(
                        res?.data?.data || []
                    );

                }

            })

            .catch((error) => {

                console.log(
                    "Followup Error",
                    error
                );

            });

    };

    const handleSendQuotationMail = async (id) => {

        try {

            const res =
                await b2bleadService.sendQuotationToMail(id);

            if (
                res?.data?.status === "success" ||
                res?.data?.status === "succsess"
            ) {

                toast.success(
                    res?.data?.message ||
                    "Quotation sent successfully"
                );

                // REFRESH FOLLOWUP
                getLeadFollowup();

            } else {

                toast.error(
                    res?.data?.message ||
                    "Failed to send quotation"
                );

            }

        } catch (error) {

            toast.error(
                error?.response?.data?.message ||
                "Something went wrong"
            );

        }

    };

    const handleSendToFship = async (id) => {

        try {

            const res =
                await b2bleadService.sendToFship(id);

            if (
                res?.data?.status === "success" ||
                res?.data?.status === "succsess"
            ) {

                toast.success(
                    res?.data?.message ||
                    "Quotation sent to Fship successfully"
                );

                // REFRESH FOLLOWUP
                getLeadFollowup();

            } else {

                toast.error(
                    res?.data?.message ||
                    "Failed to send quotation"
                );

            }

        } catch (error) {

            toast.error(
                error?.response?.data?.message ||
                "Something went wrong"
            );

        }

    };


    const handleMarkDone = async (
        commentId,
        commentText
    ) => {

        try {

            const body = {
                comment: commentText,
            };

            const res =
                await b2bleadService.markMeetingDone(
                    commentId,
                    body
                );

            if (
                res?.data?.status === "success" ||
                res?.data?.status === "succsess"
            ) {

                toast.success(
                    res?.data?.message ||
                    "Meeting marked as done"
                );

                // REFRESH FOLLOWUP
                getLeadFollowup();

                // CLOSE INLINE PANEL
                setSelectedCommentId(null);

                setActionType("");

                setActionComment("");

            } else {

                toast.error(
                    res?.data?.message ||
                    "Failed to update"
                );

            }

        } catch (error) {

            toast.error(
                error?.response?.data?.message ||
                "Something went wrong"
            );

        }

    };

    const handleCancelMeeting = async (
        commentId,
        commentText
    ) => {

        try {

            const body = {
                comment: commentText,
            };

            const res =
                await b2bleadService.markMeetingDone(
                    commentId,
                    body
                );

            if (
                res?.data?.status === "success" ||
                res?.data?.status === "succsess"
            ) {

                toast.success(
                    res?.data?.message ||
                    "Meeting marked as done"
                );

                // REFRESH FOLLOWUP
                getLeadFollowup();

                // CLOSE INLINE PANEL
                setSelectedCommentId(null);

                setActionType("");

                setActionComment("");

            } else {

                toast.error(
                    res?.data?.message ||
                    "Failed to update"
                );

            }

        } catch (error) {

            toast.error(
                error?.response?.data?.message ||
                "Something went wrong"
            );

        }

    };


    const handleMarkCallDone = async (
        commentId,
        commentText
    ) => {

        try {

            const body = {
                comment: commentText,
            };

            const res =
                await b2bleadService.markcallupdateDone(
                    commentId,
                    body
                );

            if (
                res?.data?.status === "success" ||
                res?.data?.status === "succsess"
            ) {

                toast.success(
                    res?.data?.message ||
                    "Meeting marked as done"
                );

                // REFRESH FOLLOWUP
                getLeadFollowup();

                // CLOSE INLINE PANEL
                setCallSelectedId(null);
                setCallActionType("")
                setCallActionComment("")

            } else {

                toast.error(
                    res?.data?.message ||
                    "Failed to update"
                );

            }

        } catch (error) {

            toast.error(
                error?.response?.data?.message ||
                "Something went wrong"
            );

        }

    };

    const handleCancelCall = async (
        commentId,
        commentText
    ) => {

        try {

            const body = {
                comment: commentText,
            };

            const res =
                await b2bleadService.markcallupdateDone(
                    commentId,
                    body
                );

            if (
                res?.data?.status === "success" ||
                res?.data?.status === "succsess"
            ) {

                toast.success(
                    res?.data?.message ||
                    "Meeting marked as done"
                );

                // REFRESH FOLLOWUP
                getLeadFollowup();
                setCallSelectedId(null);
                setCallActionType("")
                setCallActionComment("")



            } else {

                toast.error(
                    res?.data?.message ||
                    "Failed to update"
                );

            }

        } catch (error) {

            toast.error(
                error?.response?.data?.message ||
                "Something went wrong"
            );

        }

    };

    return (

        <div className="page">

            {/* HEADER */}
            <TopHeader />

            <Prince />

            {/* MAIN */}
            <div className="main-content pt-0">

                <div className="container-fluid py-4">

                    {/* MAIN CARD */}
                    <div
                        className="card shadow-sm border-0 overflow-hidden"
                        style={{
                            borderRadius: "18px",
                        }}
                    >

                        {/* ===================================== */}
                        {/* TOP HEADER */}
                        {/* ===================================== */}

                        <div className="bg-light border-bottom px-4 pt-4 pb-3">

                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

                                {/* LEFT TABS */}
                                <div className="d-flex gap-4 flex-wrap">

                                    {tabs.map((tab) => (

                                        <button
                                            key={tab.value}
                                            type="button"
                                            className={`btn btn-sm fw-semibold border-0 p-0 bg-transparent ${activityTab === tab.value
                                                ? "text-primary"
                                                : "text-muted"
                                                }`}
                                            onClick={() =>
                                                setActivityTab(
                                                    tab.value
                                                )
                                            }
                                        >
                                            {tab.label}
                                        </button>

                                    ))}

                                </div>

                                {/* BACK BUTTON */}
                                <button
                                    type="button"
                                    className="btn btn-sm btn-light px-4 d-flex align-items-center"
                                    onClick={handleBack}
                                >
                                    <i className="fa fa-arrow-left me-2"></i>

                                    Back
                                </button>

                            </div>

                        </div>

                        {/* ===================================== */}
                        {/* BODY */}
                        {/* ===================================== */}

                        <div className="card-body p-4">

                            {/* ===================================== */}
                            {/* FOLLOWUP TAB */}
                            {/* ===================================== */}

                            {activityTab ===
                                "followup" && (

                                    <>

                                        {/* ACTIONS */}
                                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">

                                            {/* LEFT */}
                                            <button
                                                type="button"
                                                className="btn btn-warning btn-sm text-white fw-semibold border-0 rounded-pill"
                                                onClick={() =>
                                                    b2cactivitystageleadRef.current?.toggle()
                                                }
                                            >
                                                Stage
                                            </button>

                                            {/* RIGHT */}
                                            <div className="d-flex flex-wrap gap-2">

                                                <button
                                                    type="button"
                                                    className="btn btn-success btn-sm text-white fw-semibold border-0 rounded-pill"
                                                    onClick={() =>
                                                        b2cactivityleadtypeRef.current?.toggle()
                                                    }
                                                >
                                                    Lead Type
                                                </button>

                                                {/* <button
                                                    type="button"
                                                    className="btn btn-info btn-sm text-white fw-semibold border-0 rounded-pill"
                                                    onClick={() =>
                                                        b2cactivityquationsRef.current?.toggle()
                                                    }
                                                >
                                                    Quotation
                                                </button> */}

                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm text-white fw-semibold border-0 rounded-pill"
                                                    onClick={() =>
                                                        b2cactivitymettingupdateRef.current?.toggle()
                                                    }
                                                >
                                                    Meeting Update
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-warning btn-sm text-white fw-semibold border-0 rounded-pill"
                                                    onClick={() =>
                                                        b2cactivitycontactRef.current?.toggle()
                                                    }
                                                >
                                                    Contact Update
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm text-white fw-semibold border-0 rounded-pill"
                                                    onClick={() =>
                                                        b2cactivitycommentpostRef.current?.toggle()
                                                    }
                                                >
                                                    Post a Comment
                                                </button>

                                                <div className="d-flex gap-2">

                                                     {previousTab === "closed-won-SYTS" && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-success btn-sm text-white fw-semibold border-0 rounded-pill"
                                                        onClick={() =>
                                                            b2cactivitywonleadRef.current?.toggle()
                                                        }
                                                    >
                                                        Won
                                                    </button>
                                                     )}


                                                    {previousTab === "lost" && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm text-white fw-semibold border-0 rounded-pill"
                                                            onClick={() =>
                                                                b2cactivitylostleadRef.current?.toggle()
                                                            }
                                                        >
                                                            Lost
                                                        </button>
                                                    )}

                                                </div>

                                            </div>

                                        </div>

                                        <div className="border-top my-3"></div>

                                        {/* CARD */}
                                        <div className="card border-0 shadow-sm rounded-4 overflow-hidden">

                                            <div className="card-body p-4">

                                                {/* ALERT */}
                                                <div
                                                    className="d-flex align-items-center justify-content-between mb-4 px-3 py-3 rounded-3"
                                                    style={{
                                                        background:
                                                            "linear-gradient(90deg,#fff5f5,#fff)",

                                                        border:
                                                            "1px solid #ffe2e2",
                                                    }}
                                                >

                                                    <div className="d-flex justify-content-between align-items-start w-100">

                                                        {/* LEFT SIDE */}
                                                        <div>
                                                            {activityComments?.length === 0 && (
                                                                <div>
                                                                    <div className="fw-bold text-dark">
                                                                        No follow-ups available
                                                                    </div>

                                                                    <small className="text-muted">
                                                                        No activities scheduled yet
                                                                    </small>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* RIGHT SIDE (ALWAYS RIGHT END) */}
                                                        <div className="text-end">
                                                            <span className="badge bg-dark fs-6 px-2 py-2 rounded-pill">
                                                                Lead ID : DS{leadDetails?.id}
                                                            </span>
                                                        </div>

                                                    </div>
                                                </div>

                                                {/* COMMENT TIMELINE */}
                                                {/* COMMENTS TIMELINE */}
                                                {activityComments.map((comment, index) => (

                                                    <div
                                                        className="row g-0 mb-4"
                                                        key={index}
                                                    >

                                                        {/* DATE */}
                                                        <div className="col-md-2 position-relative text-md-center mb-4 mb-md-0">

                                                            <div className="pt-4">

                                                                <h6 className="fw-bold mb-1 text-dark">

                                                                    {comment?.createdAt
                                                                        ? new Date(comment.createdAt).toLocaleDateString(
                                                                            "en-GB",
                                                                            {
                                                                                day: "numeric",
                                                                                month: "short",
                                                                                year: "numeric",
                                                                            }
                                                                        )
                                                                        : "--"}

                                                                </h6>

                                                                <small className="text-muted fw-semibold">

                                                                    {comment?.createdAt
                                                                        ? new Date(comment.createdAt).toLocaleTimeString(
                                                                            "en-US",
                                                                            {
                                                                                hour: "2-digit",
                                                                                minute: "2-digit",
                                                                            }
                                                                        )
                                                                        : "--"}

                                                                </small>

                                                            </div>

                                                        </div>



                                                        {/* CONTENT */}
                                                        <div className="col-md-10 ps-md-4">

                                                            {/* ========================= */}
                                                            {/* COMMENT CARD */}
                                                            {/* ========================= */}


                                                            {comment?.type === "quotationUpdate" && (
                                                                <>
                                                                    {comment?.quotations?.map((quot, index) => (
                                                                        <div
                                                                            key={index}
                                                                            className="bg-white rounded-4 p-4 position-relative shadow-sm mb-4"
                                                                            style={{
                                                                                border: "1px solid #edf0f5",
                                                                            }}
                                                                        >
                                                                            <span className="badge bg-danger-subtle text-danger px-3 py-2 rounded-pill position-absolute top-0 end-0 m-3">
                                                                                Quotation
                                                                            </span>

                                                                            {/* Header */}
                                                                            <div className="d-flex align-items-center mb-4">
                                                                                <div
                                                                                    className="d-flex align-items-center justify-content-center rounded-circle text-white fw-bold me-3"
                                                                                    style={{
                                                                                        width: "52px",
                                                                                        height: "52px",
                                                                                        background:
                                                                                            "linear-gradient(135deg,#dc2626,#b91c1c)",
                                                                                    }}
                                                                                >
                                                                                    {quot?.createdBy?.charAt(0)?.toUpperCase() || "Q"}
                                                                                </div>

                                                                                <div>
                                                                                    <h6 className="fw-bold text-dark mb-1">
                                                                                        {quot?.createdBy
                                                                                            ?.charAt(0)
                                                                                            ?.toUpperCase() +
                                                                                            quot?.createdBy?.slice(1)}
                                                                                    </h6>

                                                                                    <small className="text-muted">
                                                                                        Created a proposal
                                                                                    </small>
                                                                                </div>
                                                                            </div>

                                                                            {/* Body */}
                                                                            <div
                                                                                className="rounded-3 p-3"
                                                                                style={{
                                                                                    background: "#f8fafc",
                                                                                }}
                                                                            >
                                                                                <div className="row">

                                                                                    <div className="col-md-6 mb-2">
                                                                                        <small className="text-muted d-block">
                                                                                            Consumer Name
                                                                                        </small>

                                                                                        <div className="fw-semibold text-dark">
                                                                                            {quot?.consumerName || "--"}
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-md-6 mb-2">
                                                                                        <small className="text-muted d-block">
                                                                                            Consumer Email
                                                                                        </small>

                                                                                        <div className="fw-semibold text-dark">
                                                                                            {quot?.consumerEmail || "--"}
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-md-6 mb-2">
                                                                                        <small className="text-muted d-block">
                                                                                            Consumer Phone
                                                                                        </small>

                                                                                        <div className="fw-semibold text-dark">
                                                                                            {quot?.consumerPhone || "--"}
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-md-6 mb-2">
                                                                                        <small className="text-muted d-block">
                                                                                            Quote ID
                                                                                        </small>

                                                                                        <div className="fw-semibold text-dark">
                                                                                            {quot?.followUpId || "--"}
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Plan */}
                                                                                    {quot?.plan && (
                                                                                        <div className="col-md-6 mb-2">
                                                                                            <small className="text-muted d-block">
                                                                                                Plan Name
                                                                                            </small>

                                                                                            <div className="fw-semibold text-dark">
                                                                                                {quot?.plan} (
                                                                                                {quot?.Planss?.planName || "--"})
                                                                                            </div>
                                                                                        </div>
                                                                                    )}

                                                                                    {/* Custom Plan */}
                                                                                    {quot?.customePlanId && (
                                                                                        <div className="col-md-6 mb-2">
                                                                                            <small className="text-muted d-block">
                                                                                                Custom Plan Name
                                                                                            </small>

                                                                                            <div className="fw-semibold text-dark">
                                                                                                {quot?.customePlanId} (
                                                                                                {quot?.customisePlans?.planName || "--"})
                                                                                            </div>
                                                                                        </div>
                                                                                    )}

                                                                                    <div className="col-md-6 mb-2">
                                                                                        <small className="text-muted d-block">
                                                                                            Start Date
                                                                                        </small>

                                                                                        <div className="fw-semibold text-dark">
                                                                                            {quot?.startDate || "--"}
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-md-6 mb-2">
                                                                                        <small className="text-muted d-block">
                                                                                            End Date
                                                                                        </small>

                                                                                        <div className="fw-semibold text-dark">
                                                                                            {quot?.endDate || "--"}
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-md-6 mb-2">
                                                                                        <small className="text-muted d-block">
                                                                                            Stage
                                                                                        </small>

                                                                                        <div className="fw-semibold text-dark">
                                                                                            {comment?.status
                                                                                                ?.charAt(0)
                                                                                                ?.toUpperCase() +
                                                                                                comment?.status?.slice(1)}
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* PDF */}
                                                                                    {quot?.proposalPdf?.length > 0 && (
                                                                                        <div className="col-md-6 mb-2">
                                                                                            <small className="text-muted d-block">
                                                                                                Proposal PDF
                                                                                            </small>

                                                                                            <a
                                                                                                href={quot?.proposalPdf}
                                                                                                target="_blank"
                                                                                                rel="noreferrer"
                                                                                                className="fw-semibold text-primary"
                                                                                            >
                                                                                                View PDF
                                                                                            </a>
                                                                                        </div>
                                                                                    )}
                                                                                </div>

                                                                                {/* Buttons */}
                                                                                {index + 1 === comment?.quotations?.length && (
                                                                                    <div className="d-flex flex-wrap gap-2 mt-4">
                                                                                        {leadDetails?.isEmailSend && (
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn btn-danger btn-sm"
                                                                                                onClick={() => {
                                                                                                    handleSendToFship(quot?.followUpId);
                                                                                                }}
                                                                                            >
                                                                                                Send to Fship
                                                                                            </button>
                                                                                        )}

                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-primary btn-sm"
                                                                                            onClick={() => {
                                                                                                handleSendQuotationMail(
                                                                                                    quot?.followUpId,
                                                                                                );
                                                                                            }}
                                                                                        >
                                                                                            Send to Mail
                                                                                        </button>
                                                                                    </div>
                                                                                )}
                                                                            </div>

                                                                            {/* Footer */}
                                                                            {/* <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
          <small className="text-muted">
            {comment?.createdAtDate} |{" "}
            {comment?.createdAtTime}
          </small>
        </div> */}
                                                                        </div>
                                                                    ))}
                                                                </>
                                                            )}


                                                            {comment?.type === "leadComment" && (

                                                                <div
                                                                    className="bg-white rounded-4 p-4 position-relative shadow-sm"
                                                                    style={{
                                                                        border: "1px solid #edf0f5",
                                                                    }}
                                                                >

                                                                    <span className="badge bg-primary-subtle text-primary px-3 py-2 rounded-pill position-absolute top-0 end-0 m-3">

                                                                        Comment

                                                                    </span>

                                                                    <div className="d-flex align-items-center mb-4">

                                                                        <div
                                                                            className="d-flex align-items-center justify-content-center rounded-circle text-white fw-bold me-3"
                                                                            style={{
                                                                                width: "52px",
                                                                                height: "52px",
                                                                                background:
                                                                                    "linear-gradient(135deg,#2563eb,#1d4ed8)",
                                                                            }}
                                                                        >

                                                                            {comment?.createdBy
                                                                                ?.charAt(0)
                                                                                ?.toUpperCase() || "U"}

                                                                        </div>

                                                                        <div>

                                                                            <h6 className="fw-bold text-dark mb-1">

                                                                                {comment?.createdBy}

                                                                            </h6>

                                                                            <small className="text-muted">
                                                                                Posted a lead update
                                                                            </small>

                                                                        </div>

                                                                    </div>

                                                                    <div
                                                                        className="rounded-3 p-3"
                                                                        style={{
                                                                            background: "#f8fafc",
                                                                        }}
                                                                    >
                                                                        <small className="text-muted d-block mb-1">
                                                                            Comment
                                                                        </small>

                                                                        <div className="fw-semibold text-dark mb-2">
                                                                            {comment?.comment || "--"}
                                                                        </div>

                                                                        {/* <PhotoProvider>
                                                                            <div>
                                                                                {comment?.attachment ? (
                                                                                    <PhotoView src={comment?.attachment}>
                                                                                        <img
                                                                                            src={comment?.attachment}
                                                                                            alt="attachment"
                                                                                        />
                                                                                    </PhotoView>
                                                                                ) : (
                                                                                    <span>No Attachment</span>
                                                                                )}
                                                                            </div>
                                                                        </PhotoProvider> */}

                                                                        <PhotoProvider>
                                                                            <div>

                                                                                {comment?.attachment ? (

                                                                                    comment?.attachment
                                                                                        ?.toLowerCase()
                                                                                        ?.includes(".pdf") ? (

                                                                                        <a
                                                                                            href={comment?.attachment}
                                                                                            target="_blank"
                                                                                            rel="noreferrer"
                                                                                            className="btn btn-sm btn-danger"
                                                                                        >
                                                                                            View PDF
                                                                                        </a>

                                                                                    ) : (

                                                                                        <PhotoView src={comment?.attachment}>
                                                                                            <img
                                                                                                src={comment?.attachment}
                                                                                                alt="attachment"
                                                                                                className="img-fluid rounded-3 mt-2"
                                                                                                style={{
                                                                                                    maxHeight: "220px",
                                                                                                    objectFit: "cover",
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                            />
                                                                                        </PhotoView>

                                                                                    )

                                                                                ) : (

                                                                                    <span>No Attachment</span>

                                                                                )}

                                                                            </div>
                                                                        </PhotoProvider>
                                                                    </div>

                                                                </div>

                                                            )}



                                                            {/* ========================= */}
                                                            {/* MEETING CARD */}
                                                            {/* ========================= */}

                                                            {comment?.type === "meetingUpdate" && (

                                                                <div
                                                                    className="bg-white rounded-4 p-4 position-relative shadow-sm"
                                                                    style={{
                                                                        border: "1px solid #edf0f5",
                                                                    }}
                                                                >

                                                                    {/* BADGE */}
                                                                    <span className="badge bg-danger-subtle text-danger px-3 py-2 rounded-pill position-absolute top-0 end-0 m-3">

                                                                        Meeting

                                                                    </span>

                                                                    {/* HEADER */}
                                                                    <div className="d-flex align-items-center mb-4">

                                                                        <div
                                                                            className="d-flex align-items-center justify-content-center rounded-circle text-white fw-bold me-3"
                                                                            style={{
                                                                                width: "52px",
                                                                                height: "52px",
                                                                                background:
                                                                                    "linear-gradient(135deg,#ef4444,#dc2626)",
                                                                            }}
                                                                        >

                                                                            {comment?.createdBy
                                                                                ?.charAt(0)
                                                                                ?.toUpperCase() || "M"}

                                                                        </div>

                                                                        <div>

                                                                            <h6 className="fw-bold text-dark mb-1">

                                                                                {comment?.createdBy}

                                                                            </h6>

                                                                            <small className="text-muted">
                                                                                Posted a meeting update
                                                                            </small>

                                                                        </div>

                                                                    </div>

                                                                    {/* SUMMARY */}
                                                                    {comment?.lastCallSummary && (

                                                                        <div
                                                                            className="rounded-3 p-3 mb-3"
                                                                            style={{
                                                                                background: "#f8fafc",
                                                                            }}
                                                                        >

                                                                            <small className="text-muted d-block mb-1">
                                                                                Summary
                                                                            </small>

                                                                            <div className="fw-semibold text-dark">

                                                                                {comment?.lastCallSummary}

                                                                            </div>

                                                                        </div>

                                                                    )}

                                                                    {/* DETAILS */}
                                                                    <div className="row g-3">

                                                                        {/* VENUE */}
                                                                        <div className="col-md-6">

                                                                            <div className="bg-light rounded-3 p-3 h-100">

                                                                                <small className="text-muted d-block">
                                                                                    Meeting Venue
                                                                                </small>

                                                                                <div className="fw-semibold text-dark">

                                                                                    {comment?.meetingVenue || "--"}

                                                                                </div>

                                                                            </div>

                                                                        </div>

                                                                        {/* TYPE */}
                                                                        <div className="col-md-6">

                                                                            <div className="bg-light rounded-3 p-3 h-100">

                                                                                <small className="text-muted d-block">
                                                                                    Meeting Type
                                                                                </small>

                                                                                <div className="fw-semibold text-dark text-capitalize">

                                                                                    {comment?.meetingType || "--"}

                                                                                </div>

                                                                            </div>

                                                                        </div>

                                                                        {/* DATE */}
                                                                        <div className="col-md-6">

                                                                            <div className="bg-light rounded-3 p-3 h-100">

                                                                                <small className="text-muted d-block">
                                                                                    Meeting Date
                                                                                </small>

                                                                                <div className="fw-semibold text-dark">

                                                                                    {comment?.meetingDate || "--"}

                                                                                </div>

                                                                            </div>

                                                                        </div>

                                                                        {/* TIME */}
                                                                        <div className="col-md-6">

                                                                            <div className="bg-light rounded-3 p-3 h-100">

                                                                                <small className="text-muted d-block">
                                                                                    Meeting Time
                                                                                </small>

                                                                                <div className="fw-semibold text-dark">

                                                                                    {comment?.meetingTime
                                                                                        ? new Date(
                                                                                            `2000-01-01T${comment.meetingTime}:00`
                                                                                        ).toLocaleTimeString(
                                                                                            "en-US",
                                                                                            {
                                                                                                hour: "numeric",
                                                                                                minute: "numeric",
                                                                                                hour12: true,
                                                                                            }
                                                                                        )
                                                                                        : "--"}

                                                                                </div>

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    {/* STATUS */}
                                                                    {/* STATUS + ACTION UI */}
                                                                    <div
                                                                        className="rounded-4 p-4 mt-3"
                                                                        style={{
                                                                            background: "#f8fafc",
                                                                            border: "1px solid #edf0f5",
                                                                        }}
                                                                    >

                                                                        {/* TOP ROW */}
                                                                        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">

                                                                            {/* LEFT */}
                                                                            <div className="d-flex align-items-center gap-3 flex-wrap">

                                                                                <small className="text-muted fw-semibold mb-0">
                                                                                    Schedule Status :
                                                                                </small>

                                                                                <span
                                                                                    className={`badge rounded-pill px-3 py-2 fw-semibold ${comment?.occuranceType === "scheduled"
                                                                                        ? "bg-warning-subtle text-warning"
                                                                                        : comment?.occuranceType === "done"
                                                                                            ? "bg-success-subtle text-success"
                                                                                            : comment?.occuranceType === "cancelled"
                                                                                                ? "bg-danger-subtle text-danger"
                                                                                                : "bg-secondary-subtle text-secondary"
                                                                                        }`}
                                                                                >

                                                                                    {comment?.occuranceType || "--"}

                                                                                </span>

                                                                            </div>

                                                                            {/* RIGHT ACTIONS */}
                                                                            {comment?.occuranceType === "scheduled" && (

                                                                                <div className="d-flex gap-2">

                                                                                    {/* DONE */}
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-success btn-sm rounded-pill px-4 shadow-sm"
                                                                                        onClick={() => {

                                                                                            setActionType("done");

                                                                                            setSelectedCommentId(comment?.id);

                                                                                        }}
                                                                                    >

                                                                                        <i className="fa fa-check me-2"></i>

                                                                                        Mark Done

                                                                                    </button>

                                                                                    {/* CANCEL */}
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-danger btn-sm rounded-pill px-4 shadow-sm"
                                                                                        onClick={() => {

                                                                                            setActionType("cancel");

                                                                                            setSelectedCommentId(comment?.id);

                                                                                        }}
                                                                                    >

                                                                                        <i className="fa fa-times me-2"></i>

                                                                                        Cancel

                                                                                    </button>

                                                                                </div>

                                                                            )}

                                                                        </div>

                                                                        {/* COMMENT */}
                                                                        {comment?.comment && (

                                                                            <div
                                                                                className="mt-4 px-3 py-3 rounded-3"
                                                                                style={{
                                                                                    background: "#fafafa",
                                                                                    border: "1px solid #ececec",
                                                                                }}
                                                                            >

                                                                                <div className="d-flex align-items-start gap-2">

                                                                                    <i
                                                                                        className="fa fa-quote-left mt-1"
                                                                                        style={{
                                                                                            fontSize: "13px",
                                                                                            color: "#9ca3af",
                                                                                        }}
                                                                                    ></i>

                                                                                    <div>

                                                                                        <small
                                                                                            className="d-block mb-1"
                                                                                            style={{
                                                                                                color: "#6b7280",
                                                                                                fontSize: "12px",
                                                                                                letterSpacing: ".3px",
                                                                                            }}
                                                                                        >
                                                                                            NOTE
                                                                                        </small>

                                                                                        <div
                                                                                            className="fw-medium"
                                                                                            style={{
                                                                                                color: "#111827",
                                                                                                lineHeight: "1.7",
                                                                                                fontSize: "14px",
                                                                                            }}
                                                                                        >

                                                                                            {comment?.comment}

                                                                                        </div>

                                                                                    </div>

                                                                                </div>

                                                                            </div>

                                                                        )}

                                                                        {/* INLINE ACTION PANEL */}
                                                                        {selectedCommentId === comment?.id && (

                                                                            <div
                                                                                className="mt-4 rounded-3 overflow-hidden"
                                                                                style={{
                                                                                    border: "1px solid #e5e7eb",
                                                                                    background: "#ffffff",
                                                                                }}
                                                                            >

                                                                                {/* HEADER */}
                                                                                <div
                                                                                    className="d-flex justify-content-between align-items-center px-4 py-3"
                                                                                    style={{
                                                                                        borderBottom: "1px solid #f1f5f9",
                                                                                        background: "#fcfcfc",
                                                                                    }}
                                                                                >

                                                                                    <div>

                                                                                        <h6
                                                                                            className="mb-1 fw-semibold"
                                                                                            style={{
                                                                                                fontSize: "15px",
                                                                                                color: "#111827",
                                                                                            }}
                                                                                        >

                                                                                            {actionType === "done"
                                                                                                ? "Complete Meeting"
                                                                                                : "Cancel Meeting"}

                                                                                        </h6>

                                                                                        <small
                                                                                            style={{
                                                                                                color: "#6b7280",
                                                                                                fontSize: "12px",
                                                                                            }}
                                                                                        >

                                                                                            Add a short update for activity timeline

                                                                                        </small>

                                                                                    </div>

                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-sm border-0 shadow-none"
                                                                                        onClick={() => {

                                                                                            setSelectedCommentId(null);

                                                                                            setActionType("");

                                                                                            setActionComment("");

                                                                                        }}
                                                                                    >

                                                                                        <i
                                                                                            className="fa fa-times"
                                                                                            style={{
                                                                                                color: "#6b7280",
                                                                                            }}
                                                                                        ></i>

                                                                                    </button>

                                                                                </div>

                                                                                {/* BODY */}
                                                                                <div className="p-4">

                                                                                    <textarea
                                                                                        className="form-control shadow-none"
                                                                                        rows="4"
                                                                                        placeholder={
                                                                                            actionType === "done"
                                                                                                ? "Write completion summary..."
                                                                                                : "Write cancellation reason..."
                                                                                        }
                                                                                        value={actionComment}
                                                                                        onChange={(e) =>
                                                                                            setActionComment(
                                                                                                e.target.value
                                                                                            )
                                                                                        }
                                                                                        style={{
                                                                                            resize: "none",
                                                                                            borderRadius: "12px",
                                                                                            border: "1px solid #d1d5db",
                                                                                            padding: "14px",
                                                                                            fontSize: "14px",
                                                                                        }}
                                                                                    />

                                                                                    {/* FOOTER */}
                                                                                    <div className="d-flex justify-content-end gap-2 mt-4">

                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn  btn-sm btn-light px-4 rounded-pill"
                                                                                            style={{
                                                                                                border: "1px solid #d1d5db",
                                                                                            }}
                                                                                            onClick={() => {

                                                                                                setSelectedCommentId(null);

                                                                                                setActionType("");

                                                                                                setActionComment("");

                                                                                            }}
                                                                                        >

                                                                                            Close

                                                                                        </button>

                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm px-4 rounded-pill text-white"
                                                                                            style={{
                                                                                                background:
                                                                                                    actionType === "done"
                                                                                                        ? "#111827"
                                                                                                        : "#374151",

                                                                                                border: "none",
                                                                                            }}
                                                                                            onClick={() => {

                                                                                                if (actionType === "done") {

                                                                                                    handleMarkDone(
                                                                                                        comment?.id,
                                                                                                        actionComment
                                                                                                    );

                                                                                                } else {

                                                                                                    handleCancelMeeting(
                                                                                                        comment?.id,
                                                                                                        actionComment
                                                                                                    );

                                                                                                }

                                                                                            }}
                                                                                        >

                                                                                            {actionType === "done"
                                                                                                ? "Complete"
                                                                                                : "Cancel Meeting"}

                                                                                        </button>

                                                                                    </div>

                                                                                </div>

                                                                            </div>

                                                                        )}

                                                                    </div>

                                                                </div>

                                                            )}

                                                            {comment?.type === "callUpdate" && (

                                                                <div
                                                                    className="bg-white rounded-4 p-4 position-relative shadow-sm mb-3"
                                                                    style={{ border: "1px solid #edf0f5" }}
                                                                >

                                                                    {/* BADGE */}
                                                                    <span className="badge bg-info-subtle text-info px-3 py-2 rounded-pill position-absolute top-0 end-0 m-3">
                                                                        {/* Call Update */}
                                                                        {/* {setActivityComments?.activityLabel || "No Update"} */}

                                                                        {comment?.contactType}

                                                                    </span>

                                                                    {/* HEADER */}
                                                                    <div className="d-flex align-items-center mb-4">

                                                                        <div
                                                                            className="d-flex align-items-center justify-content-center rounded-circle text-white fw-bold me-3"
                                                                            style={{
                                                                                width: "52px",
                                                                                height: "52px",
                                                                                background: "linear-gradient(135deg,#2563eb,#1d4ed8)",
                                                                            }}
                                                                        >
                                                                            {comment?.createdBy?.charAt(0)?.toUpperCase() || "U"}
                                                                        </div>

                                                                        <div>
                                                                            <h6 className="fw-bold text-dark mb-1">
                                                                                {comment?.createdBy}
                                                                            </h6>
                                                                            <small className="text-muted">
                                                                                Posted a call update
                                                                            </small>
                                                                        </div>

                                                                    </div>

                                                                    {/* SUMMARY */}
                                                                    {/* <div className="rounded-3 p-3 mb-3" style={{ background: "#f8fafc" }}>
                                                                        <small className="text-muted d-block mb-1">Summary</small>
                                                                        <div className="fw-semibold text-dark">
                                                                            {comment?.lastCallSummary || "--"}
                                                                        </div>
                                                                    </div> */}

                                                                    {/* DETAILS */}
                                                                    <div className="row g-3">

                                                                        <div className="col-md-6">
                                                                            <div className="bg-light rounded-3 p-3 h-100">
                                                                                <small className="text-muted d-block">Summary</small>
                                                                                <div className="fw-semibold text-dark">
                                                                                    {comment?.lastCallSummary || "--"}
                                                                                </div>
                                                                            </div>

                                                                        </div>


                                                                        <div className="col-md-6">
                                                                            <div className="bg-light rounded-3 p-3 h-100">
                                                                                <small className="text-muted d-block">Call Back Date</small>
                                                                                <div className="fw-semibold text-dark">
                                                                                    {comment?.callBackDate || "--"}
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-md-6">
                                                                            <div className="bg-light rounded-3 p-3 h-100">
                                                                                <small className="text-muted d-block">Call Back Time</small>
                                                                                <div className="fw-semibold text-dark">
                                                                                    {comment?.callBackTime
                                                                                        ? new Date(`2000-01-01T${comment.callBackTime}:00`)
                                                                                            .toLocaleTimeString("en-US", {
                                                                                                hour: "numeric",
                                                                                                minute: "numeric",
                                                                                                hour12: true,
                                                                                            })
                                                                                        : "--"}
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                    {/* STATUS + ACTIONS */}
                                                                    <div
                                                                        className="rounded-4 p-4 mt-3"
                                                                        style={{
                                                                            background: "#f8fafc",
                                                                            border: "1px solid #edf0f5",
                                                                        }}
                                                                    >

                                                                        {/* TOP ROW: STATUS + ACTIONS */}
                                                                        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">

                                                                            {/* STATUS */}
                                                                            <div className="d-flex align-items-center gap-3 flex-wrap">

                                                                                <small className="text-muted fw-semibold mb-0">
                                                                                    Activity Status :
                                                                                </small>

                                                                                <span
                                                                                    className={`badge rounded-pill px-3 py-2 fw-semibold ${comment?.occuranceType === "scheduled"
                                                                                        ? "bg-warning-subtle text-warning"
                                                                                        : comment?.occuranceType === "done"
                                                                                            ? "bg-success-subtle text-success"
                                                                                            : comment?.occuranceType === "cancelled"
                                                                                                ? "bg-danger-subtle text-danger"
                                                                                                : "bg-secondary-subtle text-secondary"
                                                                                        }`}
                                                                                >
                                                                                    {comment?.occuranceType || "--"}
                                                                                </span>

                                                                            </div>

                                                                            {/* ACTION BUTTONS */}
                                                                            {comment?.occuranceType === "scheduled" && (
                                                                                <div className="d-flex gap-2">

                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-success btn-sm rounded-pill px-4 shadow-sm"
                                                                                        onClick={() => {
                                                                                            setCallActionType("done");
                                                                                            setCallSelectedId(comment?.id);
                                                                                            setCallActionComment("");
                                                                                        }}
                                                                                    >
                                                                                        <i className="fa fa-check me-2"></i>
                                                                                        Mark Done
                                                                                    </button>

                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-danger btn-sm rounded-pill px-4 shadow-sm"
                                                                                        onClick={() => {
                                                                                            setCallActionType("cancel");
                                                                                            setCallSelectedId(comment?.id);
                                                                                            setCallActionComment("");
                                                                                        }}
                                                                                    >
                                                                                        <i className="fa fa-times me-2"></i>
                                                                                        Cancel
                                                                                    </button>

                                                                                </div>
                                                                            )}

                                                                        </div>

                                                                        {/* ✅ NOTE INSIDE SAME CONTAINER (FIXED) */}
                                                                        {comment?.comment && (
                                                                            <div
                                                                                className="mt-4 p-3 rounded-3"
                                                                                style={{
                                                                                    background: "#ffffff",
                                                                                    border: "1px solid #e5e7eb",
                                                                                }}
                                                                            >

                                                                                <div className="d-flex align-items-start gap-2">

                                                                                    <i
                                                                                        className="fa fa-quote-left mt-1"
                                                                                        style={{
                                                                                            fontSize: "13px",
                                                                                            color: "#9ca3af",
                                                                                        }}
                                                                                    />

                                                                                    <div>

                                                                                        <small
                                                                                            className="d-block mb-1"
                                                                                            style={{
                                                                                                color: "#6b7280",
                                                                                                fontSize: "12px",
                                                                                                letterSpacing: ".3px",
                                                                                            }}
                                                                                        >
                                                                                            NOTE
                                                                                        </small>

                                                                                        <div
                                                                                            className="fw-medium"
                                                                                            style={{
                                                                                                color: "#111827",
                                                                                                lineHeight: "1.7",
                                                                                                fontSize: "14px",
                                                                                            }}
                                                                                        >
                                                                                            {comment?.comment}
                                                                                        </div>

                                                                                    </div>

                                                                                </div>

                                                                            </div>
                                                                        )}

                                                                    </div>



                                                                    {callSelectedId === comment?.id && (

                                                                        <div
                                                                            className="mt-4 rounded-3 overflow-hidden"
                                                                            style={{
                                                                                border: "1px solid #e5e7eb",
                                                                                background: "#ffffff",
                                                                            }}
                                                                        >

                                                                            {/* HEADER */}
                                                                            <div
                                                                                className="d-flex justify-content-between align-items-center px-4 py-3"
                                                                                style={{
                                                                                    borderBottom: "1px solid #f1f5f9",
                                                                                    background: "#fcfcfc",
                                                                                }}
                                                                            >

                                                                                <div>

                                                                                    <h6 className="mb-1 fw-semibold">
                                                                                        {callActionType === "done"
                                                                                            ? "Complete Call"
                                                                                            : "Cancel Call"}
                                                                                    </h6>

                                                                                    <small className="text-muted">
                                                                                        Add a short update for activity timeline
                                                                                    </small>

                                                                                </div>

                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm border-0 shadow-none"
                                                                                    onClick={() => {
                                                                                        setCallSelectedId(null);
                                                                                        setCallActionType("");
                                                                                        setCallActionComment("");
                                                                                    }}
                                                                                >
                                                                                    <i className="fa fa-times text-muted"></i>
                                                                                </button>

                                                                            </div>

                                                                            {/* BODY */}
                                                                            <div className="p-4">

                                                                                <textarea
                                                                                    className="form-control shadow-none"
                                                                                    rows="4"
                                                                                    placeholder={
                                                                                        callActionType === "done"
                                                                                            ? "Write completion summary..."
                                                                                            : "Write cancellation reason..."
                                                                                    }
                                                                                    value={callActionComment}
                                                                                    onChange={(e) =>
                                                                                        setCallActionComment(e.target.value)
                                                                                    }
                                                                                />

                                                                                {/* FOOTER */}
                                                                                <div className="d-flex justify-content-end gap-2 mt-4">

                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-light btn-sm px-4 rounded-pill"
                                                                                        onClick={() => {
                                                                                            setCallSelectedId(null);
                                                                                            setCallActionType("");
                                                                                            setCallActionComment("");
                                                                                        }}
                                                                                    >
                                                                                        Close
                                                                                    </button>

                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-sm px-4 rounded-pill text-white"
                                                                                        style={{
                                                                                            background:
                                                                                                callActionType === "done"
                                                                                                    ? "#111827"
                                                                                                    : "#374151",
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            if (callActionType === "done") {
                                                                                                handleMarkCallDone(
                                                                                                    callSelectedId,
                                                                                                    callActionComment
                                                                                                );
                                                                                            } else {
                                                                                                handleCancelCall(
                                                                                                    callSelectedId,
                                                                                                    callActionComment
                                                                                                );
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        {callActionType === "done"
                                                                                            ? "Complete"
                                                                                            : "Cancel Call"}
                                                                                    </button>

                                                                                </div>

                                                                            </div>

                                                                        </div>

                                                                    )}

                                                                </div>

                                                            )}

                                                        </div>

                                                    </div>

                                                ))}



                                                {/* TIMELINE */}
                                                <div className="position-relative">

                                                    {/* LINE */}
                                                    <div
                                                        className="position-absolute top-0 start-0 h-100 d-none d-md-block"
                                                        style={{
                                                            width: "2px",

                                                            background:
                                                                "#e9ecef",

                                                            left: "92px",
                                                        }}
                                                    ></div>

                                                    <div className="row g-0">

                                                        {/* DATE */}
                                                        <div className="col-md-2 position-relative text-md-center mb-4 mb-md-0">

                                                            <div className="pt-4">

                                                                <h6 className="fw-bold mb-1 text-dark">
                                                                    {leadDetails?.createdAtDate
                                                                        ? new Date(leadDetails.createdAt).toLocaleDateString(
                                                                            "en-GB",
                                                                            {
                                                                                day: "numeric",
                                                                                month: "short",
                                                                                year: "numeric",
                                                                            }
                                                                        )
                                                                        : "--"}
                                                                </h6>

                                                                <small className="text-muted fw-semibold">
                                                                    {leadDetails?.createdAtDate
                                                                        ? new Date(leadDetails.createdAt).toLocaleTimeString(
                                                                            "en-US",
                                                                            {
                                                                                hour: "2-digit",
                                                                                minute: "2-digit",
                                                                            }
                                                                        )
                                                                        : "--"}
                                                                </small>

                                                            </div>

                                                        </div>

                                                        {/* CONTENT */}
                                                        <div className="col-md-10 ps-md-4">

                                                            <div
                                                                className="bg-white rounded-4 p-4 position-relative shadow-sm"
                                                                style={{
                                                                    border: "1px solid #edf0f5",
                                                                }}
                                                            >

                                                                <span className="badge bg-danger-subtle text-danger px-3 py-2 rounded-pill position-absolute top-0 end-0 m-3">

                                                                    {leadDetails?.status
                                                                        ? leadDetails.status
                                                                            .charAt(0)
                                                                            .toUpperCase() +
                                                                        leadDetails.status.slice(1)
                                                                        : "New Lead"}

                                                                </span>

                                                                <div className="mb-4">

                                                                    <h5 className="fw-bold text-dark mb-1">

                                                                        {leadDetails?.createdBy} Added a New Sales Lead

                                                                    </h5>

                                                                    <small className="text-muted">
                                                                        CRM lead activity details
                                                                    </small>

                                                                </div>

                                                                <div className="row g-3">

                                                                    {/* FULL NAME */}
                                                                    <div className="col-md-6">

                                                                        <div className="bg-light rounded-3 p-3 h-100">

                                                                            <small className="text-muted d-block">
                                                                                Full Name
                                                                            </small>

                                                                            <div className="fw-semibold text-dark">

                                                                                {leadDetails?.primaryContactName || "--"}

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    {/* COMPANY */}
                                                                    <div className="col-md-6">

                                                                        <div className="bg-light rounded-3 p-3 h-100">

                                                                            <small className="text-muted d-block">
                                                                                Company
                                                                            </small>

                                                                            <div className="fw-semibold text-dark">

                                                                                {leadDetails?.companyName || "--"}

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    {/* EMAIL */}
                                                                    <div className="col-md-6">

                                                                        <div className="bg-light rounded-3 p-3 h-100">

                                                                            <small className="text-muted d-block">
                                                                                Email
                                                                            </small>

                                                                            <div className="fw-semibold text-dark text-break">

                                                                                {leadDetails?.emailId || "--"}

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    {/* PHONE */}
                                                                    <div className="col-md-6">

                                                                        <div className="bg-light rounded-3 p-3 h-100">

                                                                            <small className="text-muted d-block">
                                                                                Phone
                                                                            </small>

                                                                            <div className="fw-semibold text-dark">

                                                                                +91 {leadDetails?.mobileNumber || "--"}

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    {/* STAGE */}
                                                                    <div className="col-md-6">

                                                                        <div className="bg-light rounded-3 p-3 h-100">

                                                                            <small className="text-muted d-block">
                                                                                Stage
                                                                            </small>

                                                                            <div className="fw-semibold text-primary">

                                                                                {leadDetails?.b2bStatus
                                                                                    ? leadDetails.b2bStatus
                                                                                        .charAt(0)
                                                                                        .toUpperCase() +
                                                                                    leadDetails.b2bStatus.slice(1)
                                                                                    : "--"}

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    {/* LEAD TYPE */}
                                                                    <div className="col-md-6">

                                                                        <div className="bg-light rounded-3 p-3 h-100">

                                                                            <small className="text-muted d-block">
                                                                                Lead Type
                                                                            </small>

                                                                            <div className="fw-semibold text-danger">

                                                                                {leadDetails?.b2bLeadType || "--"}

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </>

                                )}



                            {activityTab ===
                                "update" && (
                                    // <UpdateLead leadDetails={leadDetails} />
                                    <B2BUpdateLead leadDetails={leadDetails} />

                                )}



                            {activityTab ===
                                "quotation" && (
                                    <B2BPlanQuations />

                                    // <B2CPlanQuations />

                                )}

                        </div>

                    </div>

                </div>

                {/* MODALS */}

                <B2BActivityLeadStageModal
                    ref={
                        b2cactivitystageleadRef
                    }
                    leadDetails={leadDetails}
                    getLeadData={getData}
                />
                <B2BActivityLeadTypeModal
                    ref={
                        b2cactivityleadtypeRef
                    }
                    leadDetails={leadDetails}
                    getLeadData={getData}
                />

                <B2BActivityQuationsModal
                    ref={
                        b2cactivityquationsRef
                    }
                    leadDetails={leadDetails}
                    getLeadData={getData}
                    getLeadFollowup={getLeadFollowup}
                />

                <B2BActivityMettingUpdateModal
                    ref={
                        b2cactivitymettingupdateRef
                    }
                    leadDetails={leadDetails}
                    getLeadData={getData}
                    getLeadFollowup={getLeadFollowup}
                />

                <B2BActivityContactModal
                    ref={
                        b2cactivitycontactRef
                    }
                    leadDetails={leadDetails}
                    getLeadData={getData}
                    getLeadFollowup={getLeadFollowup}
                />

                <B2BActivityPostCommentModal
                    ref={b2cactivitycommentpostRef}
                    leadDetails={leadDetails}
                    getLeadData={getData}
                    getLeadFollowup={getLeadFollowup}
                />

                <B2BWonLeadModal
                    ref={
                        b2cactivitywonleadRef
                    }
                    leadDetails={leadDetails}
                    getLeadData={getData}
                />

                <B2BLostLeadModal
                    ref={
                        b2cactivitylostleadRef
                    }
                    leadDetails={leadDetails}
                    getLeadData={getData}
                />


            </div>

            {/* FOOTER */}
            <div className="main-footer text-center mt-4">

                <div className="container">

                    <div className="col-md-12">

                        <span>
                            Copyright © 2024{" "}

                            <a href="/">
                                FSHIP
                            </a>

                            . Developed by{" "}

                            <a href="http://fship.in/">
                                FSHIP
                            </a>{" "}

                            All rights reserved.
                        </span>

                    </div>

                </div>

            </div>

        </div>

    );

};